import { useEffect, useState } from "react";
import Tags from "./Tags";
import useDimensions from "react-cool-dimensions";

function App() {
  const [posts, setPosts] = useState(undefined);
  const { observe, width } = useDimensions({});

  useEffect(() => {
    const fileUrl =
      "https://220san9z.api.sanity.io/v2021-10-21/data/query/production?query=*%5B_type%3D%3D%22instagram%22%20%5D%20%7C%20order(date%20desc)%20%7B%0Alink%2C%0A%20%20%22image%22%3A%20post.asset-%3Eurl%2C%0A%7D";

    fetch(fileUrl)
      .then((res) => res.json())
      .then((res) => {
        setPosts(res.result);
        console.log(res.result);
      });
  }, []);

  return (
    <>
      <Tags />

      {posts && (
        <div className="flex justify-center">
          <div
            className="shadow-lg md:pt-5 w-full"
            style={{ maxWidth: "500px" }}
          >
            <div className="text-center text-6xl py-2">
              <h1>ETRA</h1>
            </div>
            <div className="grid grid-cols-3 gap-1 pt-1">
              {posts.map((post, key) => {
                return (
                  <a key={key} href={post.link} ref={observe}>
                    <img
                      src={`${post.image}?auto=format&w=${parseInt(
                        width *
                          (window.devicePixelRatio
                            ? window.devicePixelRatio
                            : 1)
                      )}`}
                      alt="post"
                      className="w-full transition-all aspect-square object-left object-cover hover:brightness-75"
                    />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
